import { getCurrentProfileSelect } from '../get-current'
import { createSelector } from 'reselect'
import { getLoggedPlansCountProfileUtil } from '../../../../../models/profile/utils'

const getLoggedPlansCountProfileSelect = createSelector(getCurrentProfileSelect,
  (profile) => getLoggedPlansCountProfileUtil(profile)
)

export default getLoggedPlansCountProfileSelect
